import { FormControl, InputLabel, Select, SelectProps, styled } from '@mui/material';
import React, { ReactElement } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoFieldErrorText from ':src/components/MoFieldErrorText';

const StyledSelect = styled(Select)(
  ({ theme }) => `
  select {
    background-color: #fff;
    padding: 1rem;
    border: 1px solid ${theme.palette.grey[400]};
    border-radius: ${theme.shape.borderRadius}px;
    text-overflow: ellipsis;
    transition: border-color 300ms;

    &:focus {
      border-width: 2px;
      padding: calc(1rem - 1px);
      border-radius: ${theme.shape.borderRadius}px;
      border-color: ${theme.palette.primary.main};
      background-color: #fff;
    }
  }
  &.Mui-error {
    select {
      border-color: ${theme.palette.error.main};
    }
  }

  svg {
    right: 0.5rem;
  }
`,
);

export interface MoSelectProps extends SelectProps {
  name: string;
  label?: string;
  helperText?: string;
}

export default function MoSelect({
  name,
  label,
  fullWidth = true,
  error,
  helperText,
  ...props
}: MoSelectProps): ReactElement {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel htmlFor={name} error={error}>
        {label}
      </InputLabel>
      <StyledSelect
        id={name}
        label={label}
        IconComponent={KeyboardArrowDownIcon}
        fullWidth={fullWidth}
        error={error}
        {...props}
      />
      {error && helperText && <MoFieldErrorText>{helperText}</MoFieldErrorText>}
    </FormControl>
  );
}
